import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const sanityClient = createClient({
  projectId: 'pp96r11n',
  dataset: 'production',
  apiVersion: '2023-10-01',
  useCdn: true,
  token: undefined, 
  withCredentials: false,
});

const builder = imageUrlBuilder(sanityClient);

export async function getUtilityLinks() {
  return sanityClient.fetch(`*[_type == "utilityLink" && isActive == true]
    | order(order asc, name asc, _id asc) {
      _id, name, url, order, shortDescription, backupUrl
    }`);
}

export const urlFor = (source) => {
  if (!source) return null;
  return builder.image(source);
};

// Query to get all products
export async function getAllProducts() {
  const query = `*[_type == "product"] | order(order asc, _createdAt desc) {
    _id,
    name,
    "slug": slug.current,
    category,
    price,
    players,
    duration,
    age,
    mainImage,
    badge,
    shortDescription
  }`;

  return await sanityClient.fetch(query);
}

// Query to get a single product by slug
export async function getProductBySlug(slug) {
  const query = `*[_type == "product" && slug.current == $slug][0] {
    _id,
    name,
    "slug": slug.current,
    category,
    price,
    players,
    duration,
    age,
    mainImage,
    badge,
    shortDescription,
    description,
    learningOutcomes,
    components,
    galleryImages,
    videoId
  }`;
  
  return await sanityClient.fetch(query, { slug });
}

// Query to get all trainers, sorted by display order
export async function getAllTrainers() {
  const query = `*[_type == "trainer" && isActive != false] | order(order asc, _createdAt desc) {
    _id,
    name,
    shortDescription,
    image
  }`;

  return await sanityClient.fetch(query);
}

// Query to get all game masters, sorted by display order
export async function getAllGameMasters() {
  const query = `*[_type == "gameMaster" && isActive != false] | order(order asc, _createdAt desc) {
    _id,
    name,
    shortDescription,
    image
  }`;

  return await sanityClient.fetch(query);
}

// Query to get programs for one academy page ("corporate" | "government"),
// newest first
export async function getProgramsByCategory(category) {
  const query = `*[_type == "program" && category == $category && isActive != false]
    | order(date desc, _createdAt desc) {
    _id,
    name,
    date,
    description,
    mainImage,
    gallery,
    link
  }`;

  return await sanityClient.fetch(query, { category });
}

// Query to get all press articles, sorted by display order
export async function getAllPress() {
  const query = `*[_type == "press" && isActive != false] | order(order asc, _createdAt desc) {
    _id,
    outlet,
    title,
    date,
    excerpt,
    link,
    logo
  }`;

  return await sanityClient.fetch(query);
}

// Query to get products by category
export async function getProductsByCategory(category) {
  const query = `*[_type == "product" && category == $category] | order(order asc, _createdAt desc) {
    _id,
    name,
    "slug": slug.current,
    category,
    price,
    players,
    duration,
    age,
    mainImage,
    badge,
    shortDescription
  }`;
  
  return await sanityClient.fetch(query, { category });
}
